import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import { SearchInput } from "components";

import { getSurchargeSettingsList } from "../../surchargeUtils";
import { NavLink } from "react-router-dom";
import API from "util/API";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { authAdminMiddleWare } from "util/authAdmin";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import { updateUserkeyword } from "store/actions/account";
import { useConfirm } from "material-ui-confirm";
import ListContext from '../../ListContext';

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const SurchargeListToolbar = (props) => {
  const { className, ...rest } = props;
  const confirm = useConfirm();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.account.user);
  const selectedUserIds = useSelector((state) => state.account.selectedUserIds);
  const showSuccessMessage = (msg) => dispatch(showSuccessSnackbar(msg));
  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));
  const updateFilter = (key) => dispatch(updateUserkeyword(key));
  const { selecteItemId } = useContext(ListContext);
  const restaurant = useSelector(
    (state) => state.restaurant.selectedRestaurant
  );


  const deleteSurcharge =  async () => {
    console.log("selecteItemId", selecteItemId);
    if (!selecteItemId) {
      showErrorMessage("Please select a surcharge");
      return;
    }

    confirm({ description: "You are about to delete this surcharge" })
      .then(() => {
        updateSurchargeSettings();
        // deleteOneUser();
      })
      .catch(() => {
        /* ... */
      });
  };

  const filterUsers = (e) => {
    updateFilter(e.target.value);
  }; 

  const addRestaurants = () => {
      if(selectedUserIds.length !== 1) {
        showErrorMessage("Please select only one restaurant group account.");
        return;
      }
      setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const preparePayload = () => {

   
    const existingSurchargeSettings = getSurchargeSettingsList(restaurant);
    const newSurchargeSettings = existingSurchargeSettings.filter
    (item => item.id !== selecteItemId);
   
    return newSurchargeSettings;
  };


  const updateSurchargeSettings = async () => {
    if (!restaurant) {
      showErrorMessage('Please go back to the restaurant screen and try again.');
      return;
    }


    setButtonLoading(true);
    try {
      await API.put("/updateRestaurantValues/", {
        surchargeSettings: preparePayload(),
      })

      setButtonLoading(false);
      showSuccessMessage('Updated successfully');
      history.push("/myRestaurant");
      // if (user.role === "restaurantAdmin") {
      //   history.push("/myRestaurant");
      // } else {
      //   history.push("/restaurants");
      // }

    } catch (error) {
      if (error.response && error.response.status === 403) {
        props.history.push("/sign-in");
      }
      // console.log(JSON.stringify(error));
      setButtonLoading(false);

    }
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />

        <IconButton
          aria-label="delete"
          onClick={deleteSurcharge}
          disabled={buttonLoading}
        >
          <DeleteIcon />
        </IconButton>

     

        <NavLink to={"/surcharge"}>
          <Button color="primary" variant="outlined">
            Add New Surcharge
          </Button>
        </NavLink>
      </div>
      {/* <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search surcharge"
          value={searchText}
          onChange={handleChange}
        />
      </div> */}
    </div>
  );
};

SurchargeListToolbar.propTypes = {
  className: PropTypes.string,
};

export default SurchargeListToolbar;
